import { render, staticRenderFns } from "./SectionLink.vue?vue&type=template&id=00983656&scoped=true&lang=pug&"
import script from "./SectionLink.vue?vue&type=script&lang=js&"
export * from "./SectionLink.vue?vue&type=script&lang=js&"
import style0 from "./SectionLink.vue?vue&type=style&index=0&id=00983656&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00983656",
  null
  
)

export default component.exports